<template>
  <div class="Footer">
    <template v-if="isMobile(true)">
        <b-navbar toggleable="lg" type="dark" variant="info" class="container footerSecMob">
            <b-row>
                <b-col sm='6'>
                    <b-navbar-brand href="https://ocs-software.com/">
                        <b-img class="logo" src="https://wp-ocssport.ocs-sport.com/ocs-digital/wp-content/uploads/sites/2/2023/03/OCS_Software_Logo_2017_WO.png"></b-img>
                    </b-navbar-brand>
                </b-col>
                <b-col sm='6'>
                    <div class="wereConnected">
                        <h5 class="connected">WE’RE CONNECTED</h5>
                        <p class="FooterText">OCS Studios is part of OCS Software, offering well <br>established digital skills to businesses who want leading edge technology solutions.</p>
                    </div>
                    <b-navbar-nav class="ml-auto">
                        <b-nav-item class="navItems" href="#about" right>@ OCS Studios is a Trading name of iOffice Ltd</b-nav-item>
                    </b-navbar-nav>
                </b-col>
            </b-row>
        </b-navbar>
    </template>
    <template v-else>
        <b-navbar toggleable="lg" type="dark" variant="info" class="container">
            <b-navbar-brand href="https://ocs-software.com/">
                <b-img class="logo" src="https://wp-ocssport.ocs-sport.com/ocs-digital/wp-content/uploads/sites/2/2023/03/OCS_Software_Logo_2017_WO.png"></b-img>
            </b-navbar-brand>
            <div class="wereConnected">
                <h5 class="connected">WE’RE CONNECTED</h5>
                <p class="FooterText">OCS Digital is part of OCS Software, offering well <br>established digital skills to businesses who want leading edge technology solutions.</p>
            </div>
            <b-navbar-nav class="ml-auto">
                <b-nav-item class="navItems foot" href="#about" right>@ OCS Digital is a Trading name of  iOffice Ltd</b-nav-item>
            </b-navbar-nav>
        </b-navbar>
    </template>

  </div>
</template>

<script>
export default {
    name: 'Footer',
    methods: {
        isMobile() {
            if( screen.width <= 500 ) {
                return true;
            }
            else {
                return false;
            }
        },
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
li.nav-item.navItems.foot > a:hover {
    color: #fff;
}
.wereConnected {
    padding-left: 30px;
    padding-left: 30px;
    padding-top: 15px;
}
.navItems {
    font-size: 12px;
}
p.FooterText {
    text-align: left;
    font-size: 12px;
}
h5.connected {
    font-size: 16px;
    text-align: left;
}
.navbar-dark .navbar-nav .nav-link {
    color: #fff;
}
.logo {
    width: 100px;
    margin-top: -20px;
}
.bg-info {
    background-color: #000 !important;
}
.Footer {
    background-color: #000;
    padding-top: 30px;
    padding-bottom: 30px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
@media only screen and (max-width: 1650px) {
  .TopHomeback-Image {
    background-image: url('https://wp-ocssport.ocs-sport.com/ocs-digital/wp-content/uploads/sites/2/2023/03/HeaderImage_OCS_Studios.png');
    background-repeat: no-repeat;
    background-size: contain;
    /* background-size: 100% 100%; */
    height: 75vh;
  }
}
@media only screen and (max-width: 500px) {
    .logo {
        /* padding-bottom: 20px; */
    }
    a.navbar-brand {
        margin-right: 0;
    }
    .wereConnected {
        padding-left: 0px;
        padding-left: 0px;
        padding-top: 15px;
    }
    .navItems {
        font-size: 12px;
    }
    p.FooterText {
        text-align: center;
        font-size: 12px;
    }
    h5.connected {
        font-size: 16px;
        text-align: center;
    }
}
</style>
